import _regeneratorRuntime from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/**
 * Chrome version 66 and 67 did not call the process() function of an AudioWorkletProcessor if it had no outputs. AudioWorklet support was
 * enabled by default in version 66.
 */
export var createTestAudioWorkletProcessorNoOutputsSupport = function createTestAudioWorkletProcessorNoOutputsSupport(nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var blob, offlineAudioContext, url, isCallingProcess, gainNode, audioWorkletNode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(nativeAudioWorkletNodeConstructor === null)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", true);

          case 2:
            if (!(nativeOfflineAudioContextConstructor === null)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", false);

          case 4:
            blob = new Blob(['class A extends AudioWorkletProcessor{process(){this.port.postMessage(0)}}registerProcessor("a",A)'], {
              type: 'application/javascript; charset=utf-8'
            });
            offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 128, 3200);
            url = URL.createObjectURL(blob);
            isCallingProcess = false;
            _context.prev = 8;
            _context.next = 11;
            return offlineAudioContext.audioWorklet.addModule(url);

          case 11:
            gainNode = offlineAudioContext.createGain();
            audioWorkletNode = new nativeAudioWorkletNodeConstructor(offlineAudioContext, 'a', {
              numberOfOutputs: 0
            });

            audioWorkletNode.port.onmessage = function () {
              return isCallingProcess = true;
            };

            gainNode.connect(audioWorkletNode);
            _context.next = 17;
            return offlineAudioContext.startRendering();

          case 17:
            _context.next = 21;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](8);

          case 21:
            _context.prev = 21;
            URL.revokeObjectURL(url);
            return _context.finish(21);

          case 24:
            return _context.abrupt("return", isCallingProcess);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[8, 19, 21, 24]]);
  }));
};